import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const criteria = ["Tire Replacement", "Flat Tire Repair", "Wheel Alignment", "TPMS Sensor Service", "Brake Service", "Oil Change"];
export default function JoinOurCommunity() {
  return <section data-section-id="239913" id="expert-tire-solutions" className="dark bg-background text-foreground relative py-20 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-center items-center">
        <div className="w-[800px] h-[800px] bg-primary/10 rounded-full blur-3xl opacity-30 transform -translate-y-1/4"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black font-default text-foreground mb-6 tracking-tighter italic uppercase">
            Expert Tire Solutions
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
            From everyday replacement tires to premium performance options, Nova Tire Center keeps Los Angeles moving with fast, professional service.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-card/80 backdrop-blur-md rounded-sm shadow-3xl border border-border p-8 md:p-12 lg:p-16 border-t-primary border-t-4">
          <h2 className="text-2xl md:text-3xl font-black font-default text-foreground text-center mb-10 uppercase italic tracking-tight">
            Our Service Standards
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12">
            {criteria.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-4 p-4 rounded-sm hover:bg-primary/10 transition-colors duration-300 border border-transparent hover:border-primary/20">
                <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                <span className="text-foreground font-bold text-lg font-default uppercase tracking-tight">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="tel:+14243138474">
              <Button size="lg" className="text-base px-8 h-12 rounded-sm font-black uppercase italic bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg transition-all hover:-translate-y-0.5">
                Call Now
              </Button>
            </Link>
            <Link to="tel:+14243138474">
              <Button variant="outline" size="lg" className="text-base px-8 h-12 rounded-sm font-black uppercase italic border-primary text-primary hover:bg-primary/10 transition-all">
                Call Now
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}